var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vs-input", {
    staticClass: "w-100 pr-4",
    attrs: {
      placeholder: "Busque por nombre, alias, correo o rut",
      icon: "search",
      autofocus: "true",
      "data-cy": "search"
    },
    on: { keyup: _vm.searchUser },
    model: {
      value: _vm.text,
      callback: function($$v) {
        _vm.text = typeof $$v === "string" ? $$v.trim() : $$v
      },
      expression: "text"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }